import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { toCurrency } from '../../utils/table';

// eslint-disable-next-line arrow-parens
export default Component => {
  const wrapper = class RTTreeTable extends React.Component {
    constructor(props) {
      super(props);
      this.TrComponent.bind(this);
      this.getTrProps.bind(this);
      this.getTrGroupProps.bind(this);
    }

    // This is so we can expose the underlying ReactTable to get at the sortedData for selectAll
    getWrappedInstance = () => {
      // eslint-disable-next-line no-console
      if (!this.wrappedInstance) console.warn('RTTreeTable - No wrapped instance');
      if (this.wrappedInstance.getWrappedInstance) return this.wrappedInstance.getWrappedInstance();
      return this.wrappedInstance;
    }

    getTrProps = (state, ri) => ({ ri });


    // This adds cutom classes and ids to each table row group.
    getTrGroupProps = (state, group) => {
      if (group.subRows) {
        return({
          className: 'rt-tr-group-parent'
        });
      }
      return({
        className: 'rt-tr-group-child'
      });
    };

    // This is to not override the default click behavior of table cells.
    getTdProps = () => ({
      onClick: (e, handleOriginal) => {
        if (handleOriginal) {
          handleOriginal();
        }
      }
    });

    TrComponent = (props) => {
      const { ri, ...rest } = props;
      const { treeTableIndent } = this.props;

      if (ri && ri.groupedByPivot) {
        const cell = { ...props.children[ri.level] };

        // Get the type of cell from source table and add to row classes
        const addClasses = ri.row._subRows[0].rowType || '';

        // Create a classname for specific styling of each treetable aggregation level
        const levelClasses = `level-${ri.level}`;
        cell.props.style.flex = 'unset';
        cell.props.style.width = '100%';
        cell.props.style.maxWidth = 'unset';
        cell.props.style.paddingLeft = `${treeTableIndent * ri.level}px`;

        return(
          <div className={`rt-tr ${rest.className} ${levelClasses} ${addClasses}`} role="row" style={rest.style}>
            {cell}
          </div>
        );
      }
      return<Component.defaultProps.TrComponent {...rest} />;
    }

    render() {
      const {
        columns, treeTableIndent, aggregateBy, ...rest
      } = this.props;
      const {
        TrComponent, getTrProps, getTrGroupProps, getTdProps
      } = this;

      const extra = {
        columns: columns.map((col) => {
          let column = col;

          if (rest.pivotBy && (rest.pivotBy.includes(col.accessor) || rest.pivotBy.includes(col.id))) {
            column = {
              id: col.id,
              accessor: col.accessor,
              width: `${treeTableIndent}px`,
              show: false,
              className: 'pivot-row',
              Header: '',
              Expander: ({
                isExpanded, row, subRows, value
              }) => {
                let childRow;
                if (subRows[0]._pivotID) {
                  childRow = subRows[0]._pivotID;
                } else {
                  childRow = (Object.keys(row)).find((key) => row[key] === false);
                }
                return(
                // Add a custom button expander fo a11y compliance
                  <button
                    type="button"
                    className={classnames('rt-expander', 'rt-expander--custom', isExpanded && '-open')}
                    aria-expanded={!!isExpanded}
                    aria-label={isExpanded ? `Collapse ${childRow} rows under ${col.Header}, ${value}` : `Expand ${childRow} rows under ${col.Header}, ${value}`}
                  >
&bull;
                  </button>
                );
              },
              PivotValue: (prop) => {
                if (prop.row._pivotVal) {
                  const labelBy = (prop.level > 0 && prop.subRows && rest.pivotBy) ? prop.subRows[0][rest.pivotBy[prop.level - 1]] : null;
                  return(
                    <React.Fragment>
                      <div className="string pivot-name left" role="gridcell" style={{ minWidth: `${col.minWidth}px` }} id={prop.value} aria-labelledby={labelBy}>{prop.value === 'null' ? '' : prop.value}</div>
                      {
                        aggregateBy && aggregateBy.map((aggregator, index) => {
                          if (prop.row[aggregator] >= 0) {
                            // eslint-disable-next-line react/no-array-index-key
                            return(<div className="rt-td currency pivot-value right" role="gridcell" style={{ minWidth: `${col.minWidth - 2}px` }} key={`${prop.row[aggregator]}-${index}`}><span style={{ width: '100%' }}>{toCurrency(prop.row[aggregator])}</span></div>);
                          }
                          return null;
                        })
                      }
                    </React.Fragment>
                  );
                } return null;
              },
              Pivot: col.Pivot
            };
          }
          return column;
        }),
        TrComponent,
        getTrProps,
        getTrGroupProps,
        getTdProps,
        getResizerProps: () => ({ className: 'rt-resizer--treetable' })
      };
      return<Component {...rest} {...extra} ref={(r) => { this.wrappedInstance = r; }} />;
    }
  };
  wrapper.displayName = 'RTTreeTable';
  wrapper.propTypes = {
    treeTableIndent: PropTypes.number,
    aggregateBy: PropTypes.array,
    columns: PropTypes.object
  };
  wrapper.defaultProps = {
    treeTableIndent: 10
  };
  return wrapper;
};
